import { render, staticRenderFns } from "./MilitaryTrain.vue?vue&type=template&id=1c2410b4&scoped=true&"
import script from "./MilitaryTrain.vue?vue&type=script&lang=js&"
export * from "./MilitaryTrain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2410b4",
  null
  
)

export default component.exports